type GenerateYearType =
  | 'before-now'
  | 'one-before-then-3-after'
  | 'before-5-years'
  | '';

export const generateYearList = (type?: GenerateYearType, year?: number) => {
  const currentYear = new Date().getFullYear();
  const yearList: string[] = [];

  if (type === 'before-5-years' && !year) {
    for (let i = currentYear - 5; i <= currentYear; i++) {
      yearList.push(i.toString());
    }
  }

  if (type === 'before-now' && !year) {
    for (let i = currentYear - 5; i <= currentYear; i++) {
      yearList.push(i.toString());
    }
    for (let i = currentYear + 1; i <= currentYear + 5; i++) {
      yearList.push(i.toString());
    }
  }
  if (type === 'one-before-then-3-after' && !year) {
    for (let i = currentYear - 1; i <= currentYear + 3; i++) {
      yearList.push(i.toString());
    }
  }

  if (year) {
    for (let i = currentYear; i >= currentYear - (year - 1); i--) {
      yearList.push(i.toString());
    }
  }

  return yearList;
};
